// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

const t = require('app/scripts/views/internal/teacupWithHelpers').teacupWithHelpers(
  'board_header',
);

module.exports = t.renderable(function ({
  name,
  canRename,
  isLoggedIn,
  isUntitled,
  canJoin,
  canInviteMembers,
  canAssign,
  showCopyButton,
  isEmbeddedInAtlassian,
  isTemplate,
  starTooltipKey,
  hasEditPrivileges,
  shouldRenderPartialReactBoardHeader,
}) {
  const classes = {
    'board-header-btn': true,
    'mod-board-name': true,
    'inline-rename-board': true,
    'js-rename-board': canRename,
    'no-edit': !canRename,
    'should-rename': isUntitled && canRename,
  };

  const renderMembersFacepileAndBoardShareButton = function () {
    t.span('.board-header-btn-divider');
    t.div('.board-header-btns.mod-left', function () {
      if (shouldRenderPartialReactBoardHeader) {
        t.div('.js-react-board-header-facepile.react-board-header-facepile');
      } else {
        t.div('.board-header-facepile.js-fill-facepile', {
          class: t.classify({ 'js-list-draggable-board-members': canAssign }),
        });

        t.a(
          '#member-count.board-header-btn.board-header-btn-member-count.js-open-show-all-board-members.js-fill-board-member-count',
          { href: '#' },
          function () {},
        );
      }

      if (canInviteMembers) {
        t.span('.board-share-button');
      }

      if (shouldRenderPartialReactBoardHeader) {
        return t.span(
          '.js-react-board-header-join-button.react-board-header-join-button',
        );
      } else {
        if (canJoin && !isTemplate) {
          return t.a(
            '.board-header-btn.board-header-btn-without-icon.board-header-btn-join-board.js-join-board',
            { href: '#', title: t.l('workspace-members-can-join-this-board') },
            () =>
              // hovertext to replace helper
              t.span('.board-header-btn-text', () => t.format('join-board')),
          );
        }
      }
    });
  };

  if (shouldRenderPartialReactBoardHeader) {
    t.div('.js-react-header-wrapper.react-header-wrapper');
  } else {
    t.div({ href: '#', class: t.classify(classes) }, function () {
      t.h1(
        '.js-board-editing-target.board-header-btn-text',
        { dir: 'auto' },
        () => t.text(name),
      );

      return t.input('.board-name-input.js-board-name-input', {
        'aria-label': name,
        spellcheck: 'false',
        dir: 'auto',
        maxLength: 512,
        value: name,
      });
    });

    if (isTemplate) {
      t.div('.board-header-btn-template-badge.js-board-template-badge');
    }

    if (isLoggedIn) {
      t.a(
        '.board-header-btn.js-star-board.board-header-star-container',
        {
          href: '#',
          title: t.l(starTooltipKey),
          'aria-label': t.l('star-or-unstar-board'),
        },
        () => t.icon('star', { class: 'board-header-btn-icon' }),
      );
    }
  }

  t.div(
    '.js-board-header-btn-org-wrapper.board-header-btn-org-wrapper',
    function () {
      t.span('.board-header-btn-divider');

      return t.a('.board-header-btn.perms-btn.js-change-vis', {
        href: '#',
        id: 'permission-level',
      });
    },
  );

  t.span('.board-header-btn-divider');
  t.div('.js-board-views-switcher');

  t.div('.board-header-btns.mod-right', function () {
    t.a(
      '.board-header-btn.sub-btn.hide.js-board-header-subscribed',
      { href: '#' },
      function () {
        t.icon('subscribe', { class: 'board-header-btn-icon' });
        return t.span('.board-header-btn-text', () => t.format('watch'));
      },
    );

    if (!isEmbeddedInAtlassian) {
      t.span('.js-pup-header-btns board-header-btn-react-container');

      t.span('.js-calendar-board-btn board-header-btn-react-container');

      t.a('.board-header-btn.hide.js-map-btn', { href: '#' }, function () {
        t.span('.icon-sm.icon-location.board-header-btn-icon');
        return t.span('.board-header-btn-text', () => t.format('map'));
      });

      t.span('.js-plugin-header-btns');
    }

    if (isLoggedIn && showCopyButton && !isTemplate) {
      t.a('.board-header-btn.js-copy-board', { href: '#' }, function () {
        t.icon('board', { class: 'board-header-btn-icon' });
        return t.span('.board-header-btn-text', () => t.format('copy-board'));
      });
    }

    if (hasEditPrivileges && !isEmbeddedInAtlassian) {
      t.span('.js-pup-dropdown-list-btn board-header-btn-react-container');
      t.span('.js-butler-header-btns board-header-btn-react-container');
    }

    t.span('.board-header-btn-divider');

    t.span(
      '.js-brita-board-filter-btn-container board-header-btn-react-container',
    );

    renderMembersFacepileAndBoardShareButton();

    t.span('.board-header-btn-divider');

    t.span('.show-sidebar-button-react-root');
  });

  t.div('#workspaces-auto-name-alert');
});
